import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { ONBOARDING_CATALOGS } from "./model/onboarding-copy.ts";
import { ONBOARDING_ERROR_COPY } from "./model/onboarding-error-copy.ts";

export const onboardingBrowserModule: BrowserModule = defineBrowserModule("onboarding")
  .withErrorCopy(ONBOARDING_ERROR_COPY)
  .withScreens({
    onboarding: {
      path: "/onboarding",
      title: phrase(ONBOARDING_CATALOGS, "screenTitleGetStarted"),
      layout: "auth",
      load: () => import("./ui/sections/onboarding-screen.tsx"),
    },
    completeProfile: {
      path: "/complete-profile",
      title: phrase(ONBOARDING_CATALOGS, "screenTitleProfile"),
      layout: "auth",
      load: () => import("./ui/sections/profile-screen.tsx"),
    },
  });
